import styled from 'styled-components';

export const Container = styled.div`
  .list-group-item.active {
    background-color: ${(props) => props.theme.$bg_blue};
    border-color: ${(props) => props.theme.$bg_blue};
  }
`;
